'use client';

import { Spacer, Toaster } from 'components/ui-kit';
import { CertificateProperties } from 'lib/models/certificates.response';
import styles from './certificate.module.scss';
import { CertificateForm } from './components/form/certificate-form.component';

type TCertificateProps = {
  certificates: Array<CertificateProperties>;
};

export const Certificate = ({
  certificates,
}: TCertificateProps): JSX.Element => {
  return (
    <>
      <div className={styles.hero}>
        <div className={styles.container}>
          <div className={styles.heroInner}>
            <img
              className={styles.sign}
              src="/images/page/certificate/certificate.svg"
              alt="Сертификат"
            />
            <Spacer size={24} />
            <h2 className={styles.heroText}>
              Растопите сердце, не ломая голову. <br />
              Универсальный подарок для коллег, друзей и близких.
            </h2>
          </div>
        </div>
      </div>
      <CertificateForm certificates={certificates} />
      <Toaster />
    </>
  );
};
